import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import Collapse from "@material-ui/core/Collapse";
import CardMK from "../../../../components/Card/Card.js";

import CardHeader from "../../../../components/Card/CardHeader";

import CardBody from "../../../../components/Card/CardBody";

import CardFooter from "../../../../components/Card/CardFooter";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAstronaut } from "@fortawesome/free-solid-svg-icons";

import styles from "../serviceStyle";

const useStyles = makeStyles(styles);
export default function InnovazioneCard() {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 1800);

  const [expanded, setExpanded] = React.useState(false);
  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const classes = useStyles();

  return (
    <CardMK className={classes[cardAnimaton]}>
      <CardHeader
        color="primary"
        className={classes.cardHeader}
        onClick={handleExpand}
      >
        <div className={classes.socialLine}>
          <Button className={classes.headerIcon} onClick={handleExpand}>
            <FontAwesomeIcon
              icon={faUserAstronaut}
              className={classes.cardIconHover}
            />
          </Button>
        </div>
        <h4 className={classes.cardH4}>
          L'innovazione imposta dall'esterno in modo costoso e rischioso non fa
          per te
          {/* Senti che l'innovazione ti viene imposta dall'esterno in modo costoso
          e rischioso? */}
        </h4>
      </CardHeader>
      <Button
        color="primary"
        onClick={handleExpand}
        className={classes.bottonCollaps}
      >
        Vorresti partire dalle tue risorse per ...
        <ExpandMoreIcon
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
        />
      </Button>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardBody>
          <Typography variant="body2">
            favorire nuove idee in un ambiente creativo
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="body2">
            stare al passo con l'innovazione digitale
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="body2">
            alimentare una vocazione al miglioramento continuo
          </Typography>
          <Divider className={classes.divider} />
        </CardBody>
        <CardFooter className={classes.cardFooter}>
          <Button
            variant="contained"
            size="large"
            className={classes.cardBottonButton}
            component={Link}
            to={{
              pathname: "/servizi",
              hash: "#innovazioneRef",
              state: {
                fromDashboard: true,
                targetRef: "innovazioneRef",
              },
            }}
          >
            Cosa proponiamo noi?
          </Button>
        </CardFooter>
      </Collapse>
    </CardMK>
  );
}
